<template>
  <FlashOffer v-if="hasDataBoost">
    <template #previous>
      {{
        i18n(translations.dataAmountBoost, {
          dataAmount: baseOffer.dataAmount,
        })
      }}
    </template>
    <template #new>
      {{
        i18n(translations.dataAmountBoost, {
          dataAmount: offer.dataAmount,
        })
      }}
    </template>

    <slot />
  </FlashOffer>

  <FlashOffer v-if="hasSubsidyBoost">
    <template #previous>
      {{
        i18n.price(baseOffer.subsidy, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      }}
    </template>
    <template #new>
      {{
        i18n(translations.subsidyAmountBoost, {
          subsidy: i18n.price(offer.subsidy, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }),
        })
      }}
    </template>

    <slot />
  </FlashOffer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import type { ReadonlyDeep } from 'type-fest'

import translations from './MobilePlanFlashOffer.translations'
import FlashOffer from './components/FlashOffer/FlashOffer.vue'

const i18n = useI18n()

const props = defineProps<{
  offer: MobilePlanOffer | ReadonlyDeep<MobilePlanOffer>
  baseOffer: NonNullable<MobilePlanOffer['baseOffer']>
}>()

const hasDataBoost = computed(() => {
  if (!props.offer.baseOffer) return false

  return props.offer.dataAmount > props.baseOffer.dataAmount
})

const hasSubsidyBoost = computed(() => {
  if (!props.offer.baseOffer) return false

  const currentSubsidy = Number(props.offer.subsidy.amount)
  const baseSubsidy = Number(props.baseOffer.subsidy.amount)

  return currentSubsidy > baseSubsidy
})
</script>
